<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center"></div>
      <div class="d-sm-flex align-items-center">
        <input
          type="text"
          class="form-control shadow-none text-black rounded-0"
          placeholder="Chercher"
          @change="getRecords()"
          @input="getRecords"
          v-model="filter.searchTerm"
        />
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-scroll-outer">
        <div class="table-scroll-mobile">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Code d'envoi
              </th>

              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Destinataire
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Magasin
              </th>

              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Status
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Ville
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Prix
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date de création
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Produits
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <th
                class="shadow-none lh-1 fw-medium text-black-emphasis title ps-0"
              >
                <div class="d-flex align-items-center">
                  <h6 v-if="row.replace === 1" class="text-warning">
                    {{ row.code }}
                    <i class="ph ph-repeat"></i>
                  </h6>
                  <h6 v-else-if="row.partial === 1" class="text-info">
                    {{ row.code }}
                    <i class="ph ph-arrows-down-up"></i>
                  </h6>
                  <h6 v-else>
                    {{ row.code }}
                  </h6>
                </div>
              </th>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <p class="text-nowrap">
                  <b>{{ row.receiver }}</b> <br />
                  <b>{{ oldPhone(row.phone) }}</b> <br />
                </p>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b v-if="row.magasin_name">Magasin : {{ row.magasin_name }} </b>

                <div v-else class="text-nowrap">
                  {{ row.customer_name }}<br />
                  {{ oldPhone(row.customer_phone) }}
                </div>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <div
                  class="rounded-pill fs-13 badge text-bg-black custom-badge"
                  :style="{ '--dynamic-bg': getBadgeConfig(row).color }"
                >
                  {{ getBadgeConfig(row).text }}
                  <template v-if="getBadgeConfig(row).date">
                    <br />{{ getBadgeConfig(row).date }}
                  </template>
                  <template v-if="getBadgeConfig(row).comment">
                    <br />{{ getBadgeConfig(row).comment }}
                  </template>
                </div>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b>{{ row.city_name }}</b
                ><br />
                <p v-if="row.quartier && row.quartier.name">
                  {{ row.quartier.name }}
                </p>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b>{{ row.price }} </b>{{ $devis }}<br />
                <p style="word-wrap: break-word; width: 50%">
                  {{ row.product_nature }}
                </p>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ getDate(row.created_at) }}
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <b>{{ row.nb_pros || 0 }}</b> Produits
              </td>

              <td
                class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0"
              >
                <div class="dropdown">
                  <button
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <button
                        class="dropdown-item d-flex align-items-center"
                        @click="showDetails(row)"
                      >
                        <i
                          class="flaticon-view lh-1 me-8 position-relative top-1"
                        ></i>
                        Infos
                      </button>
                    </li>
                    <li>
                      <a
                        v-if="auth.can('STOCK')"
                        class="dropdown-item d-flex align-items-center"
                        href="javascript:void(0);"
                        @click="removeColis(row)"
                        ><i
                          class="flaticon-delete lh-1 me-8 position-relative top-1"
                        ></i>
                        supprimer</a
                      >
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
      >
        <p class="mb-0 text-paragraph">
          Showing
          <span class="fw-bold">
            {{ (filter.current_page - 1) * filter.per_page + 1 }}
          </span>
          –
          <span class="fw-bold">
            {{ Math.min(filter.current_page * filter.per_page, filter.total) }}
          </span>
          out of <span class="fw-bold">{{ filter.total }}</span> results
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <!-- Previous -->
            <li
              class="page-item"
              :class="{ disabled: filter.current_page === 1 }"
            >
              <a
                class="page-link"
                href="javascript:void(0)"
                aria-label="Previous"
                @click="goToPage(filter.current_page - 1)"
              >
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>

            <!-- Page numbers -->
            <li v-for="page in filter.last_page" :key="page" class="page-item">
              <a
                href="javascript:void(0)"
                class="page-link"
                :class="{ active: filter.current_page === page }"
                @click="goToPage(page)"
              >
                {{ page }}
              </a>
            </li>

            <!-- Next -->
            <li
              class="page-item"
              :class="{ disabled: filter.current_page === filter.last_page }"
            >
              <a
                class="page-link"
                href="javascript:void(0)"
                aria-label="Next"
                @click="goToPage(filter.current_page + 1)"
              >
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Filter -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Filtrer</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <form class="row">
            <!-- Magasin -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Magasin:</label>
                <v-select
                  class="custom-select-height"
                  v-model="client_filter"
                  label="name"
                  :options="clientList"
                  @search="filterClients"
                />
              </div>
            </div>

            <!-- Zone -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Zone:</label>
                <v-select
                  class="custom-select-height"
                  v-model="zone_filter"
                  label="name"
                  :options="zonesList"
                />
              </div>
            </div>

            <!-- Ville -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Ville:</label>
                <v-select
                  class="custom-select-height"
                  v-model="city_filter"
                  label="name"
                  :options="citiesList"
                />
              </div>
            </div>

            <!-- Status -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Status:</label>
                <v-select
                  class="custom-select-height"
                  v-model="status_filter"
                  style="border-color: #0000002b"
                  label="name"
                  :options="status"
                />
              </div>
            </div>

            <!-- Par Date -->
            <div class="col-md-4">
              <div class="form-group mb-3">
                <label>Par Date:</label>
                <!-- Add your datepicker here -->
              </div>
            </div>
          </form>
        </div>

        <div class="modal-footer">
          <!-- <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            Fermer
          </button> -->
          <button type="button" @click="filterList" class="btn btn-primary">
            Annuler
          </button>
          <button type="button" @click="removeFilter" class="btn btn-warning">
            Appliquer
          </button>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="detailColisModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Informations colis</h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-md-6">
              <div
                class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
              >
                <div
                  class="card-header d-flex justify-content-between align-items-center"
                >
                  <h5 class="mb-0">Informarion Colis :</h5>
                </div>

                <div class="card-body p-15 p-sm-20 p-md-25">
                  <ul class="list-unstyled my-1">
                    <li>
                      <span class="align-middle">
                        <b class="bclass">Store :</b>

                        {{ coliDetails?.magasin_name }}
                      </span>
                    </li>
                    <li class="my-25">
                      <span class="align-middle"
                        ><b class="bclass">Téléphone : </b>

                        {{ coliDetails?.magasin?.phone_store }}
                      </span>
                    </li>
                    <li>
                      <span class="align-middle">
                        <b class="bclass">Client :</b>
                        {{ coliDetails?.store }}</span
                      >
                    </li>
                    <li>
                      <span class="align-middle">
                        <b class="bclass">Responsable :</b>
                        {{ coliDetails?.customer_name }}</span
                      >
                    </li>

                    <!-- <li>
                  <h4>Client :</h4><span class="align-middle">Basic Support</span>
                </li> -->
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div
                class="card mb-25 border-0 rounded-0 bg-white letter-spacing"
              >
                <div
                  class="card-header d-flex justify-content-between align-items-center"
                >
                  <h5 class="mb-0">Information Bon livraison</h5>
                </div>
                <div class="card-body p-15 p-sm-20 p-md-25">
                  <ul class="list-unstyled my-1">
                    <li>
                      <span class="align-middle"
                        ><b class="bclass">Code d'envoie :</b>
                        {{ coliDetails?.code }}</span
                      >
                    </li>
                    <li class="my-25">
                      <span class="align-middle"
                        ><b class="bclass">Destinataire :</b>
                        {{ coliDetails?.receiver }}</span
                      >
                    </li>
                    <li class="my-25">
                      <span class="align-middle"
                        ><b class="bclass">Téléphone :</b>
                        {{ coliDetails?.phone }}</span
                      >
                    </li>
                    <li class="my-25">
                      <span class="align-middle"
                        ><b class="bclass">Ville :</b>
                        {{ coliDetails?.city_name }}</span
                      >
                    </li>
                    <li class="my-25">
                      <span class="align-middle"
                        ><b class="bclass">Adresse :</b>
                        {{ coliDetails?.address }}</span
                      >
                    </li>
                    <li class="my-25">
                      <span class="align-middle"
                        ><b class="bclass">Commentaire :</b>
                        {{ coliDetails?.note }}</span
                      >
                    </li>
                    <li class="my-25">
                      <span class="align-middle"
                        ><b class="bclass">Quartier :</b>
                        {{ coliDetails?.quartier }}</span
                      >
                    </li>
                    <li>
                      <span class="align-middle"
                        ><b class="bclass">Nature Produit :</b>
                        {{ coliDetails?.product_nature }}</span
                      >
                    </li>
                    <li>
                      <span class="align-middle"
                        ><b class="bclass">Crbt :</b>
                        {{ coliDetails?.price }} {{ $devis }}</span
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <hr />

          <table class="table table-sm table-bordered mt-20">
            <thead>
              <tr class="dn-inv-table-head">
                <th>Photo</th>
                <th>Nom du produit</th>
                <th>Quantité</th>
              </tr>
            </thead>

            <tbody>
              <template v-if="colisContents.length != 0">
                <tr
                  class="dn-inv-table-body"
                  v-for="(prod, index) in colisContents"
                  :key="index"
                >
                  <td class="td-nowrap">
                    <!-- <b-avatar size="32" :src="path + prod.product_pic" class="mx-1" /> -->
                    <img
                      v-if="prod.product_pic && prod.product_pic != null"
                      height="50"
                      width="50"
                      :src="prod.product_pic"
                    />
                    <img
                      v-else-if="prod.product_pic == null"
                      height="50"
                      width="50"
                      :src="require('@/assets/images/NoImage.png')"
                    />
                  </td>
                  <td class="parcel-status td-nowrap">
                    <b>
                      {{ prod.product_name }}
                    </b>
                  </td>
                  <td>
                    <b>{{ prod.qnty }} : </b> {{ prod.variant_name }}<br />
                    {{ prod.product_name }}<br />
                  </td>
                </tr>
              </template>
              <tr v-else class="dn-inv-table-body">
                <td colspan="8" style="text-align: center">
                  Aucun produit trouvé.
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script  lang="ts">
import { onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { Modal } from "bootstrap";

export default {
  name: "StockColis",
  components: {},
  setup: () => {
    const { showToast } = useAppToast();
    const leadPlaceholder = "Select Lead Date";
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);
    const isLoaderColi = ref(false);

    const filter = reactive({
      surrent_page: 1,
      per_page: 10,

      searchTerm: "",
      searchCustomer: "",
      searchZone: "",
      searchLiv: "",
      searchCity: "",
      searchEtat: "",
      searchStatut: "",
      searchSDate: "",
      searchEDate: "",
      searchTypeDate: "",
      searchBPL: "",
      searchRef: "",
      searchEmail: "",
      searchPrice: "",

      // (optional) pagination/meta from API:
      total: 0,
      last_page: 1,
      current_page: 1,
    });

    const zone_filter = ref({ id: "", name: "" });
    const client_filter = ref({ id: "", name: "" });
    const liv_filter = ref({ id: "", name: "" });
    const city_filter = ref({ id: "", name: "" });
    const status_filter = ref({ id: "", name: "", code: "" });

    const etat_filter = ref("");
    const type_date_filter = ref("");
    const add_bp_filter = ref("");
    const ref_filter = ref("");
    const email_filter = ref("");
    const price_filter = ref("");
    const searchTerm = ref("");

    interface Status {
      code: string;
      name: string;
      code_color?: string;
    }

    const status = ref<Status[]>([]);

    const clientList = ref<Status[]>([]);
    const zonesList = ref<Status[]>([]);
    const citiesList = ref<Status[]>([]);
    const livreurList = ref<Status[]>([]);
    const etatList = ref<Status[]>([]);

    const coliDetails = ref(null);
    const colisContents = ref([]);

    function convert(date) {
      // example: to YYYY-MM-DD (adapt to your backend)
      const d = new Date(date);
      const m = String(d.getMonth() + 1).padStart(2, "0");
      const day = String(d.getDate()).padStart(2, "0");
      return `${d.getFullYear()}-${m}-${day}`;
    }

    function getDate(value) {
      if (value) return moment(String(value)).format("YYYY-MM-DD HH:mm");
      else return "";
    }

    function buildQuery() {
      const params = new URLSearchParams({
        searchTerm: filter.searchTerm || "",
        searchCustomer: filter.searchCustomer || "",
        searchZone: filter.searchZone || "",
        searchCity: filter.searchCity || "",
        searchEtat: filter.searchEtat || "",
        searchStatut: filter.searchStatut || "",
        searchSDate: filter.searchSDate || "",
        searchEDate: filter.searchEDate || "",
        page: String(filter.current_page || 1),
        per_page: String(filter.per_page || 10),
      });
      return `/api/auth/ParcelsInventory?${params.toString()}`;
    }

    onMounted(async () => {
      flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
      });

      flatpickr("#basic-calendar", {
        dateFormat: "Y-m-d H:i",
      });
      getRecords();
      fetchStatus();

      try {
        const response = await api.get(`/api/auth/ListZone`);
        if (response && response.data) {
          zonesList.value = response.data;
          zonesList.value.unshift({ code: "0", name: "Tous" });
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }

      try {
        const { data } = await api.get(`/api/auth/citiesList`);

        if (Array.isArray(data)) {
          citiesList.value = data;

          // Évite les doublons
          if (
            !citiesList.value.some(
              (city) => city.code === "0" && city.name === "Tous"
            )
          ) {
            citiesList.value.unshift({ code: "0", name: "Tous" });
          }
        }
      } catch (error) {
        console.error("Erreur lors du chargement des villes :", error);
        // showToast("Impossible de charger la liste des villes", "error")
      }
    });

    async function getRecords() {
      isLoader.value = true;
      try {
        const url = buildQuery();
        const { data } = await api.get(url);

        rows.value = data.users.data;

        // Keep your search fields; only update pagination/meta you need:
        filter.current_page = data.users.current_page;
        filter.per_page = data.users.per_page;
        filter.total = data.users.total;
        filter.last_page = data.users.last_page;

        // If you actually need all fields returned from backend:
        // Object.assign(users, { ...users, ...data.users })
      } finally {
        isLoader.value = false;
      }
    }

    function filterList() {
      filter.searchZone = zone_filter.value?.id || "";
      filter.searchCustomer = client_filter.value?.id || "";
      filter.searchLiv = liv_filter.value?.id || "";
      filter.searchCity = city_filter.value?.id || "";
      filter.searchEtat = etat_filter.value || "";
      filter.searchStatut = status_filter.value?.code || "";

      //   filter.searchSDate = myInput.value?.dateRange?.start
      //     ? convert(myInput.value.dateRange.start)
      //     : "";
      //   filter.searchEDate = myInput.value?.dateRange?.end
      //     ? convert(myInput.value.dateRange.end)
      //     : "";

      filter.searchTypeDate = type_date_filter.value || "";
      filter.searchBPL = add_bp_filter.value || "";
      filter.searchRef = ref_filter.value || "";
      filter.searchEmail = email_filter.value || "";
      filter.searchTerm = searchTerm.value || "";
      filter.searchPrice = price_filter.value || "";

      filter.current_page = 1;
      getRecords();
      hideModal("filterLeadModal");
    }

    function removeFilter() {
      // reset users filters
      filter.searchZone = "";
      filter.searchCustomer = "";
      filter.searchPrice = "";
      filter.searchLiv = "";
      filter.searchCity = "";
      filter.searchEtat = "";
      filter.searchStatut = "";

      filter.searchSDate = "";
      filter.searchEDate = "";
      filter.searchTypeDate = "";
      filter.searchBPL = "";
      filter.searchRef = "";
      filter.searchEmail = "";
      filter.searchTerm = "";
      filter.current_page = 1;

      // reset local UI models
      etat_filter.value = "";
      add_bp_filter.value = "";
      ref_filter.value = "";
      email_filter.value = "";
      type_date_filter.value = "";
      price_filter.value = "";
      searchTerm.value = "";

      zone_filter.value = { id: "", name: "" };
      client_filter.value = { id: "", name: "" };
      liv_filter.value = { id: "", name: "" };
      city_filter.value = { id: "", name: "" };
      status_filter.value = { id: "", name: "", code: "" };

      // clear date range picker model
      //   if (!myInput.value) myInput.value = { dateRange: {} }
      //   myInput.value.dateRange = {}

      getRecords();
      hideModal("filterLeadModal");
    }

    async function fetchStatus() {
      try {
        const response = await api.get("/api/auth/AllStatus");
        if (response && response.data) {
          status.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching statuses:", error);
      }
    }

    function goToPage(page) {
      if (page < 1 || page > filter.last_page) return;
      filter.current_page = page;
      getRecords();
    }

    function oldPhone(val) {
      if (val && val !== "" && val != null) {
        let phone = "";
        if (val.substring(0, 4) === "+212" && val.length === 13) {
          return `0${val.slice(4)}`;
        }
        if (val.substring(0, 3) === "212" && val.length === 12) {
          phone = `0${val.slice(2)}`;
          return phone;
        }
        if (val.substring(0, 1) === "0" && val.length === 10) {
          return val;
        }
        if (
          val.substring(0, 1) === "6" ||
          (val.substring(0, 1) === "7" && val.length === 9)
        ) {
          // phone = "+212" + val;
          return val;
        }
        if (val.substring(0, 5) === "00212" && val.length === 14) {
          return `0${val.substring(0, 5)}`;
        }
      } else {
        return val;
      }
    }
    function globalHelper(s: string) {
      if (!s || s === "undefined") {
        return null; // always return null for invalid values
      }

      return status.value.find((o) => o.code === s) || null;
    }

    function removeHours(value) {
      if (value && value !== "") {
        const datePart = value.split(" ")[0];
        return datePart;
      }
    }
    function reported(date) {
      const currentDate = new Date();
      const reportedDate = new Date(date);
      if (reportedDate.getTime() <= currentDate.getTime()) {
        return true;
      } else {
        return false;
      }
    }
    function resolveStatuParcel(status) {
      if (status === "POSTPONED") return "Reporté";
      if (status === "DELIVERED") return "Livré";
      if (status === "PAID") return "Payé";
      if (status === "NOT_PAID") return "Non Payé";
      if (status === "Payé") return "Payé";
      if (status === "CANCELED") return "Annulé";
      if (status === "UNREACHABLE") return "Injoignable";
      if (status === "POSTPONED") return "Reporté";
      if (status === "RETURNED") return "Retourné";
      if (status === "RECEIVED") return "Reçu";
      if (status === "OUT_OF_AREA") return "Hors-zone";
      if (status === "NOANSWER") return "Pas de réponse + SMS";
      if (status === "SENTED") return "Expédié";
      if (status === "REFUSE") return "Refusé";
      if (status === "ONV") return "En Voyage";
      if (status === "INT") return "Client intéréssé";
      if (status === "POSTPONED_TEAM") return "Reporté ( SUIVI )";
      if (status === "CANCELED_TEAM") return "Annulé ( SUIVI )";
      if (status === "VOICEMAIL_TEAM") return "Boite Vocal ( SUIVI )";
      if (status === "EN") return "Erreur Numéro";
      return status;
    }

    function resolveUserStatusVariant(status) {
      if (status === "PICKED_UP") return "warning";
      if (status === "DELIVERED") return "success";
      if (status === "PAID") return "info";
      if (status === "NOT_PAID") return "danger";
      if (status === "Payé") return "info";
      if (status === "Non Payé") return "warning";
      if (status === "Facturé") return "info";
      return "primary";
    }

    function getStatusName(code?: string) {
      return code ? globalHelper(code)?.name || "" : "";
    }

    function getStatusColor(code?: string) {
      return code ? globalHelper(code)?.code_color || "#000" : "#000";
    }

    function formatReported(row: any) {
      return removeHours(row.reported_date);
    }

    // Decide what to show in badge
    function getBadgeConfig(row: any) {
      // IN_PROGRESS with secondary status
      if (
        row.status === "IN_PROGRESS" &&
        row.status_second &&
        getStatusName(row.status_second)
      ) {
        if (
          ["POSTPONED", "PROGRAMED", "POSTPONED_TODAY"].includes(
            row.status_second
          )
        ) {
          return {
            text: getStatusName(row.status_second),
            date: formatReported(row),
            color: reported(row.reported_date)
              ? "#E50A0A"
              : getStatusColor(row.status_second),
          };
        }
        return {
          text: getStatusName(row.status_second),
          color: getStatusColor(row.status_second),
        };
      }

      // RETURNED but not REFUSE
      if (
        row.status === "RETURNED" &&
        (!row.status_second || row.status_second !== "REFUSE") &&
        row.last_statut_comment
      ) {
        return {
          text:
            row.rn_e && row.rn_e !== 0
              ? `${row.statut.s_name} Endommagé`
              : row.statut.s_name,
          comment: row.last_statut_comment,
          color: row.statut.code_color,
        };
      }

      // RETURNED with REFUSE
      if (
        row.status === "RETURNED" &&
        row.status_second === "REFUSE" &&
        getStatusName(row.status_second)
      ) {
        return {
          text:
            row.rn_e && row.rn_e !== 0
              ? `Retourné Endommagé - ${getStatusName(row.status_second)}`
              : `Retourné - ${getStatusName(row.status_second)}`,
          comment: row.last_statut_comment,
          color: getStatusColor(row.status_second),
        };
      }

      // Default
      return {
        text:
          row.rn_e && row.rn_e !== 0 && row.status === "RETURNED"
            ? `${row.statut.s_name} Endommagé`
            : row.statut.s_name,
        color: row.statut.code_color,
      };
    }

    let debounceTimeout: number | undefined;

    // function onSearchClients(search, loading) {
    //   clearTimeout(this.searchTimeout)
    //   this.searchTimeout = setTimeout(() => {
    //     this.filterClients(search, loading)
    //   }, 300) // Debounce time in milliseconds
    // },

    async function filterClients(search: string, loading: { value: boolean }) {
      const query = search.trim().toLowerCase();

      if (!query) {
        clientList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/ListCustsFilter`, {
            params: { query },
          });
          clientList.value = res.data;
          clientList.value.unshift({ code: "0", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          clientList.value = [];
        }
      }, 300); // 300ms debounce
    }

    async function onSearchDrivers(
      search: string,
      loading: { value: boolean }
    ) {
      const query = search.trim().toLowerCase();

      if (!query) {
        livreurList.value = [];
        return;
      }

      // Debounce to avoid too many API calls
      if (debounceTimeout) clearTimeout(debounceTimeout);

      debounceTimeout = window.setTimeout(async () => {
        try {
          const res = await api.get(`/api/auth/LivsList`, {
            params: { query },
          });
          livreurList.value = res.data;
          livreurList.value.unshift({ code: "0", name: "Tous" });
        } catch (error) {
          console.error("Error fetching clients:", error);
          livreurList.value = [];
        }
      }, 300); // 300ms debounce
    }

    const showRefs = ref(true);
    function showRefsEdit() {
      if (ref_filter.value == "1") {
        showRefs.value = true;
      } else {
        showRefs.value = false;
      }
    }

    async function showDetails(row) {
      coliDetails.value = row;
      isLoaderColi.value = true;

      try {
        const res = await api.get(
          `/api/auth/ProductColis?cstmr_id=${row.customer}&colis_id=${row.id}`
        );
        colisContents.value = res.data;
        const modalEl = document.getElementById("detailColisModal");
        const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
        modal.show();
      } catch (error) {
        console.error("Error fetching colis details:", error);
      } finally {
        isLoaderColi.value = false;
      }
    }

    async function removeColis(row) {
      const result = await Swal.fire({
        text: "Vous voulez supprimer ce colis ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Oui, supprimer!",
      });

      if (result.isConfirmed) {
        try {
          const data = new FormData();
          data.append("colis_id", row.id);
          data.append("colis_code", row.code);
          data.append("cstmr_id", row.customer);

          const res = await api.post(`/api/auth/RemoveParcelStock`, data);

          if (res.data.message === "success") {
            getRecords(); // 🔹 if this is a composition API function, don't use `this`
            showToast("Colis supprimé avec succès", "success");
          } else if (res.data.message === "error parcel") {
            showToast(
              "Erreur lors de la suppression du colis, veuillez réessayer",
              "error"
            );
          }
        } catch (error) {
          console.error("Erreur API suppression:", error);
          showToast("Erreur serveur", "error");
        }
      }
    }
    function hideModal(idModal) {
      const modalEl = document.getElementById(idModal);
      const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
      if (modal) {
        modal.hide();
      }
    }

    return {
      leadPlaceholder,
      auth,
      rows,
      goToPage,
      filter,
      getDate,
      oldPhone,
      globalHelper,
      removeHours,
      reported,
      resolveStatuParcel,
      resolveUserStatusVariant,
      getBadgeConfig,
      zone_filter,
      client_filter,
      liv_filter,
      city_filter,
      status_filter,
      showRefsEdit,
      showRefs,

      etat_filter,
      type_date_filter,
      add_bp_filter,
      ref_filter,
      email_filter,
      price_filter,
      searchTerm,

      clientList,
      zonesList,
      citiesList,
      livreurList,
      etatList,
      status,

      filterClients,
      onSearchDrivers,
      filterList,
      removeFilter,
      user,
      showDetails,
      colisContents,
      isLoaderColi,
      coliDetails,
      removeColis,

      hideModal,
      getRecords
    };
  },
};
</script>